/* eslint no-use-before-define: 0 */

import jQuery from "jquery";

(function main($) {
    $(document).ready(function onReady() {
        const propertyDescriptionComponents = $(this).find(".property-description");
        propertyDescriptionComponents.each(function grabData() {
            this.descriptionTextContainer = $(this).find(".description-text-container").first();
            this.descriptionText = this.descriptionTextContainer.find(".description-text").first();
            this.showMoreLink = $(this).find(".show-more-link").first();
            this.maxAreaHeight = $(this).data("max-area-height");
            this.rowHeight = $(this).data("row-height");
        });

        setShowMoreButtonDisplayProperties(propertyDescriptionComponents);
        let resizeTimeout;
        $(window).resize(() => {
            clearTimeout(resizeTimeout);
            resizeTimeout = setTimeout(() => {
                setShowMoreButtonDisplayProperties(propertyDescriptionComponents);
            }, 100);
        });
    });

    function setShowMoreButtonDisplayProperties(propertyDescriptionComponents) {
        propertyDescriptionComponents.each(function showOrHide() {
            if (!$(this).hasClass("experience-editor")) {
                if (this.descriptionText.height() - this.maxAreaHeight > this.rowHeight) {
                    this.showMoreLink.show();
                } else {
                    this.showMoreLink.hide();
                }
            }
        });
    }
}(jQuery));
